<div class="custom-message-banner-alert" *ngIf="customMessageBannerInfo">
  <div class="alert-red-rectangle"></div>
  <ion-icon name="alert-circle-outline"></ion-icon>
  <div
    class="custom-message-alert-text-container"
    [ngClass]="
      platformService?.platformType === platformService?.platformEnum?.mobile
        ? 'custom-message-alert-text-container-mobile'
        : ''
    "
  >
    <p class="alert-text" data-cy="home-custom-message-banner-text">
      {{ croppedText }}
    </p>

    <div
      *ngIf="
        customMessageBannerInfo.link &&
        platformService?.platformType !== platformService?.platformEnum?.mobile
      "
      class="see-more-information"
    >
      <ion-button
        data-cy="home-custom-message-banner-btn"
        class="usf-outline-orange-button"
        (click)="onClickCustomMessage()"
      >
        {{ 'i18n.common.seeMoreInformation' | translate }}
      </ion-button>
    </div>
    <div
      *ngIf="
        customMessageBannerInfo.link &&
        platformService?.platformType === platformService?.platformEnum?.mobile
      "
      class="see-more-information-mobile"
    >
      <p
        data-cy="home-custom-message-banner-link"
        class="mobile-link"
        (click)="onClickCustomMessage()"
      >
        {{ 'i18n.common.seeMoreInformation' | translate }}
      </p>
    </div>
  </div>
</div>
